import React from 'react';
import { Chip, Grid } from '@material-ui/core';
import {
  ALL,
  WAITING,
  APPROVED,
  REPROVED,
  DONE,
  WORKING,
  REVISION,
  WAITPUBLISHING,
  PUBLISHED,
  PREREVISION,
  ONHOLD,
  RETURNTOWRITER,
  REVIEWPAUSED,
  WAITINGFORTRANSLATION,
  ERRORWHENTRANSLATION,
  INTRANSLATION,
  SCHEDULED,
  AIWRITING,
  AIERROR,
  AWAITINGAIWRITING,
} from './labelsStatusContent';
import { StatusType } from '../../enums/status-type.enum';

const getStatusStyle = (status) => {
  let color;
  switch (status) {
    case StatusType.Waiting:
      color = {
        color: '#73733C',
        backgroundColor: '#f2f2c7ff',
      };
      break;
    case StatusType.Approved:
      color = {
        color: '#687065',
        backgroundColor: '#dff0d8ff',
      };
      break;
    case StatusType.Reproved:
      color = {
        color: '#736A6A',
        backgroundColor: '#f2dedeff',
      };
      break;
    case StatusType.Done:
      color = {
        color: '#383838',
        backgroundColor: '#b7b7b7ff',
      };
      break;
    case StatusType.Working:
      color = {
        color: '#805C26',
        backgroundColor: '#FFB84D',
      };
      break;
    case StatusType.Revision:
      color = {
        color: '#383B70',
        backgroundColor: '#c0c2f0ff',
      };
      break;
    case StatusType.WaitPublish:
      color = {
        color: '#572A3F',
        backgroundColor: '#d5a6bdff',
      };
      break;
    case StatusType.Published:
      color = {
        color: '#60705A',
        backgroundColor: '#A4FF80',
      };
      break;
    case StatusType.PreRevision:
      color = {
        color: '#3C5D73',
        backgroundColor: '#C7E1F2',
      };
      break;
    case StatusType.OnHold:
      color = {
        color: '#6b0522',
        backgroundColor: '#fa5584',
      };
      break;
    case StatusType.ReturnToWriter:
      color = {
        backgroundColor: '#ffda6a',
        color: '#443a18',
      };
      break;
    case StatusType.ReviewPaused:
      color = {
        backgroundColor: '#443a18',
        color: '#ffda6a',
      };
      break;
    case StatusType.ErrorWhenTranslating:
      color = {
        backgroundColor: '#572A3F',
        color: '#d5a6bdff',
      };
      break;
    case StatusType.WaitingForTranslation:
      color = {
        backgroundColor: '#73733C',
        color: '#f2f2c7ff',
      };
      break;
    case StatusType.InTranslation:
      color = {
        backgroundColor: '#60705A',
        color: '#A4FF80',
      };
      break;
    case StatusType.AiWriting:
      color = {
        backgroundColor: '#2e4f7a',
        color: '#a3c9ff',
      };
      break;
    case StatusType.AiError:
      color = {
        backgroundColor: '#7a2e2e',
        color: '#ffa3a3',
      };
      break;
    case StatusType.AwaitingAIWriting:
      color = {
        backgroundColor: '#4a5f7a',
        color: '#d4e4ff',
      };
      break;
    default:
      color = {
        color: '#383838',
        backgroundColor: '#b7b7b7ff',
      };
      break;
  }
  return color;
};

const statusChip = (status, id) => (
  <Grid container>
    <Chip
      label={status}
      style={{ ...getStatusStyle(id), ...{ minWidth: '90%' } }}
    />
  </Grid>
);

const setStatusWPLabel = (status) => {
  let statusLabel;
  switch (status) {
    case 0:
      statusLabel = 'Error';
      break;
    case 1:
      statusLabel = 'Draft';
      break;
    case 2:
      statusLabel = 'Draft pending';
      break;
    case 3:
      statusLabel = 'Publish pending';
      break;
    case 4:
      statusLabel = 'Published';
      break;
    default:
      statusLabel = '';
      break;
  }
  return statusLabel;
};

const setStatusLabel = (status) => {
  let statusLabel;
  switch (status) {
    case null:
      statusLabel = ALL;
      break;
    case StatusType.Waiting:
      statusLabel = WAITING;
      break;
    case StatusType.Approved:
      statusLabel = APPROVED;
      break;
    case StatusType.Reproved:
      statusLabel = REPROVED;
      break;
    case StatusType.Done:
      statusLabel = DONE;
      break;
    case StatusType.Working:
      statusLabel = WORKING;
      break;
    case StatusType.Revision:
      statusLabel = REVISION;
      break;
    case StatusType.WaitPublish:
      statusLabel = WAITPUBLISHING;
      break;
    case StatusType.Published:
      statusLabel = PUBLISHED;
      break;
    case StatusType.PreRevision:
      statusLabel = PREREVISION;
      break;
    case StatusType.OnHold:
      statusLabel = ONHOLD;
      break;
    case StatusType.ReturnToWriter:
      statusLabel = RETURNTOWRITER;
      break;
    case StatusType.ReviewPaused:
      statusLabel = REVIEWPAUSED;
      break;
    case StatusType.WaitingForTranslation:
      statusLabel = WAITINGFORTRANSLATION;
      break;
    case StatusType.ErrorWhenTranslating:
      statusLabel = ERRORWHENTRANSLATION;
      break;
    case StatusType.InTranslation:
      statusLabel = INTRANSLATION;
      break;
    case StatusType.Scheduled:
      statusLabel = SCHEDULED;
      break;
    case StatusType.AiWriting:
      statusLabel = AIWRITING;
      break;
    case StatusType.AiError:
      statusLabel = AIERROR;
      break;
    case StatusType.AwaitingAIWriting:
      statusLabel = AWAITINGAIWRITING;
      break;
    default:
      statusLabel = '';
      break;
  }
  return statusChip(statusLabel, status);
};

const returnStatusLabel = (status) => {
  switch (status) {
    case null:
      return ALL;
    case 0:
      return WAITING;
    case 1:
      return APPROVED;
    case 2:
      return REPROVED;
    case 3:
      return DONE;
    case 4:
      return WORKING;
    case 5:
      return REVISION;
    case 6:
      return WAITPUBLISHING;
    case 7:
      return PUBLISHED;
    case 8:
      return PREREVISION;
    case 9:
      return ONHOLD;
    case 10:
      return RETURNTOWRITER;
    case 11:
      return REVIEWPAUSED;
    case 12:
      return WAITINGFORTRANSLATION;
    case 13:
      return ERRORWHENTRANSLATION;
    case 14:
      return INTRANSLATION;
    case 15:
      return SCHEDULED;
    case 16:
      return AIWRITING;
    case 17:
      return AIERROR;
    case 18:
      return AWAITINGAIWRITING;
    default:
      return '';
  }
};
const getStatusId = (status) => {
  switch (status) {
    case ALL:
      return null;
    case WAITING:
      return StatusType.Waiting;
    case APPROVED:
      return StatusType.Approved;
    case REPROVED:
      return StatusType.Reproved;
    case DONE:
      return StatusType.Done;
    case WORKING:
      return StatusType.Working;
    case REVISION:
      return StatusType.Revision;
    case WAITPUBLISHING:
      return StatusType.WaitPublish;
    case PUBLISHED:
      return StatusType.Published;
    case PREREVISION:
      return StatusType.PreRevision;
    case ONHOLD:
      return StatusType.OnHold;
    case RETURNTOWRITER:
      return StatusType.ReturnToWriter;
    case REVIEWPAUSED:
      return StatusType.ReviewPaused;
    case WAITINGFORTRANSLATION:
      return StatusType.WaitingForTranslation;
    case ERRORWHENTRANSLATION:
      return StatusType.ErrorWhenTranslating;
    case INTRANSLATION:
      return StatusType.InTranslation;
    case SCHEDULED:
      return StatusType.Scheduled;
    case AIWRITING:
      return StatusType.AiWriting;
    case AIERROR:
      return StatusType.AiError;
    case AWAITINGAIWRITING:
      return StatusType.AwaitingAIWriting;
    default:
      return 0;
  }
};

const getStatusTextLabel = {
  [StatusType.Waiting]: WAITING,
  [StatusType.Approved]: APPROVED,
  [StatusType.Reproved]: REPROVED,
  [StatusType.Done]: DONE,
  [StatusType.Working]: WORKING,
  [StatusType.Revision]: REVISION,
  [StatusType.WaitPublish]: WAITPUBLISHING,
  [StatusType.Published]: PUBLISHED,
  [StatusType.PreRevision]: PREREVISION,
  [StatusType.OnHold]: ONHOLD,
  [StatusType.ReturnToWriter]: RETURNTOWRITER,
  [StatusType.ReviewPaused]: REVIEWPAUSED,
  [StatusType.WaitingForTranslation]: WAITINGFORTRANSLATION,
  [StatusType.ErrorWhenTranslating]: ERRORWHENTRANSLATION,
  [StatusType.ErrorWhenTranslating]: ERRORWHENTRANSLATION,
  [StatusType.InTranslation]: INTRANSLATION,
  [StatusType.Scheduled]: SCHEDULED,
  [StatusType.AiWriting]: AIWRITING,
  [StatusType.AiError]: AIERROR,
  [StatusType.AwaitingAIWriting]: AWAITINGAIWRITING,
};

export {
  setStatusLabel,
  getStatusId,
  setStatusWPLabel,
  returnStatusLabel,
  getStatusTextLabel,
};
